import { forwardRef, type AnchorHTMLAttributes } from 'react';
import { clsx } from 'clsx';
import { linkStyle } from './link.css';

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  underline?: 'always' | 'hover' | 'none';
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ underline = 'hover', className, children, style, ...props }, ref) => {
    const textDecoration =
      underline === 'always' ? 'underline'
      : underline === 'none' ? 'none'
      : undefined;

    return (
      <a
        ref={ref}
        className={clsx(linkStyle, className)}
        style={textDecoration ? { textDecoration, ...style } : style}
        {...props}
      >
        {children}
      </a>
    );
  },
);
Link.displayName = 'Link';
